import React from 'react';
import PropTypes from 'prop-types';
import isDataEmpty from '../../helpers/isDataEmpty';

import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

const ErrorBox = (props) => {
	const { submitErrors } = props;

	if (isDataEmpty(submitErrors)) {
		return null;
	}

	return (
		<Box sx={{ border: 1, borderColor: 'error.main', borderRadius: 5, p: 1, m: 1 }}>
			{submitErrors.map((error) => {
				return <Chip sx={{ m: 0.5 }} key={error.type} label={error.message} />;
			})}
		</Box>
	);
};

ErrorBox.propTypes = {
	submitErrors: PropTypes.array
};

export default ErrorBox;
